import { GoogleAnalyticsProvider } from '../providers/google-analytics.provider'
import { analyticsService } from '../services/analytics.service'
import { isGoogleAnalyticsConfigured } from './is-google-analytics-configured.utils'
import type { GoogleAnalyticsLogger, GoogleTagFn } from '../providers/google-analytics.provider'

export interface GoogleAnalyticsRegistrationConfig {
  debug?: boolean
  appEnv?: string
  providers?: {
    googleAnalytics?: { measurementId?: string }
  }
}

export type GtagFn = GoogleTagFn

/** Registers GoogleAnalyticsProvider when measurement ID and gtag are available. */
export function registerGoogleAnalyticsProvider(
  analyticsConfig: GoogleAnalyticsRegistrationConfig,
  gtagFn: GtagFn | undefined,
  logger?: GoogleAnalyticsLogger
): void {
  const measurementId = analyticsConfig.providers?.googleAnalytics?.measurementId

  if (!isGoogleAnalyticsConfigured(measurementId)) {
    logger?.debug?.('[Analytics] Google Analytics skipped — no measurement ID configured')
    return
  }

  if (!gtagFn) {
    logger?.warn('[Analytics] Google Analytics skipped — gtag not available')
    return
  }

  const googleProvider = new GoogleAnalyticsProvider(analyticsConfig.debug || false, logger)
  googleProvider.setAppEnv(analyticsConfig.appEnv ?? 'development')
  googleProvider.setGtag(gtagFn)
  analyticsService.registerProvider('googleAnalytics', googleProvider)
}
